import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class TextAligner extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            textOnTheLeft: null,
            textOnTheRight: null
        }
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize = () => {
        const baseElement = this.element.getBoundingClientRect()
        const leftElement = this.ref.textOnTheLeft.getBoundingClientRect()

        const magicValue = leftElement.top - baseElement.top
        if(window.innerWidth > 767) {
            this.ref.textOnTheRight.style.marginTop = `${magicValue}px`
        } else {
            this.ref.textOnTheRight.style.marginTop = `0px`
        }
    }
}
